import { render, staticRenderFns } from "./EmployeeDetailsRole.vue?vue&type=template&id=c250d63c"
import script from "./EmployeeDetailsRole.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailsRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports